import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import CadastroCliente from './pages/cadastroCliente/CadastroCliente';
import LancaPedido from './pages/lancaPedido/LancaPedido';
import EstouNaMesa from './pages/estounamesa';
import HistoricoPedido from './pages/historicoPedido/HistoricoPedido';
import Cardapio from "./pages/cardapio"
import Perfil from './pages/perfil/Perfil';
import Newpassword from './pages/newpassword/NewPassword';
import { Switch, Route, HashRouter, BrowserRouter } from 'react-router-dom'
import Pagamento from './pages/pagamento/Pagamento';
import { Provider } from "react-redux";
import store from "./store"


ReactDOM.render(
    <Provider store={store} >
        <BrowserRouter basename="/pedidosWebPablo">
            <Switch>
                <Route exact path="/" component={App} />
                <Route path="/homePage" component={App} />
                <Route path='/FinalizaPagamento' component={Pagamento} />
                <Route path="/CadastroCliente/:objAdress?" component={CadastroCliente} />
                <Route path='/LancaPedido' component={LancaPedido} />
                <Route path='/cardapio' component={Cardapio} />
                <Route path='/HistoricoPedidos' component={HistoricoPedido} />
                <Route path='/Perfil/:objAdress?' component={Perfil} />
                <Route path='/newpassword/:token' component={Newpassword} />
                <Route path='/estounamesa/:idLoja/:mesa' component={EstouNaMesa} />
            </Switch>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);


